import React, { Component } from "react";
import Input from "./input";
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import { fieldValidator } from './fieldValidator';


export class Form extends Component {
  /** Whether to perform validation on field changes */
  validate = true;

  state = {
    data: {},
    errors: {}
  };

  handleSubmit = e => {
    e.preventDefault();

    this.doSubmit();
  };

  handleChange = ({ currentTarget: input }) => {
    const { data, errors } = this.state;
    data[input.name] = input.value;

    this.setState({ data });

    if (this.validate) {
      errors[input.name] = fieldValidator(input.name, input.value);
      this.setState({ errors })
    }
  };

  renderButton(label, isDisabled) {
    return (
      <Button disabled={isDisabled} color="primary" variant="contained" type="submit">{label}</Button>
    );
  }

  renderCheckbox(name, label) {
    const { errors } = this.state;
    const data = { ...this.state.data };

    return (
      <div>
        {errors[name] != undefined ? <FormHelperText component="legend" error={true}>{errors[name]}</FormHelperText>: ""}
        <FormControlLabel control={
          <Checkbox
            name={name}
            onChange={(_, checked) => { data[name] = checked; this.setState({data}); }}
            color="primary"
            checked={this.state.data[name]}
          />}
          label={label} />

      </div>

    );
  }

  renderInput(name, label, type = "text", required = false) {
    const { data, errors } = this.state;

    return (
      <FormGroup>
        <Input
          type={type}
          name={name}
          value={data[name]}
          label={label}
          onChange={this.handleChange}
          error={errors[name]}
          variant="outlined"
          margin="normal"
          fullWidth={true}
          required={required}
        />

      </FormGroup>
    );
  }
}

export default Form;
